import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  TextField,
  Button,
  MenuItem,
  Paper,
  FormControl,
  InputLabel,
  Select,
  TextareaAutosize,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Autocomplete,
  Tooltip,
  Modal,
  Fade,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { AddPhotoAlternate, Close } from '@mui/icons-material';
import axios from 'axios';
import { API, graphqlOperation } from 'aws-amplify';
import { createUserIssue } from '../../graphql/mutations';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import support from '../../assets/images/support.png';
import { useSelector } from 'react-redux';
import { uploadToServer } from '../../library/upload';
import { getAccessToken, getLastAuthUser } from '../../library/shared';
import pdf from '../../assets/images/attachments/pdf.png';
import excel from '../../assets/images/attachments/xls.png';
import docx from '../../assets/images/attachments/docs.png';
import file from '../../assets/images/attachments/folder.png';
import csv from '../../assets/images/attachments/csv.png';
// import videoIcon from "../../assets/images/attachments/video.png";
import { supportedFileTypes } from '../../utils/common';
import { useDebounce } from '../../hooks/useDebounce';
import CustomPhoneInputBox from '../../components/customInputBox/CustomPhoneInputBox';
import { matchIsValidTel } from 'mui-tel-input';
import { useThemes } from '../../components/Theme/theme';
import { axiosInstanceForLambda } from '../../library/Axios';
import { createuserissue } from '../../graphql/postgress_graphql/mutations';
import API_ENDPOINTS from '../../apiEndpoints';
import { frequentlyAsked } from './frequentlyQstn';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // bgcolor: "background.paper",
  boxShadow: 'none',
  outline: 'none',
  // minWidth: { xs: "90%", md: "950px" },
  // '@media (min-width:600px)': {
  //     width: 'auto',
  // },
  width: { xs: '90%', md: '90%', lg: '80%', xl: '60%' },
  '@media (min-width:1800px)': {
    width: 'auto',
  },
  maxHeight: '90vh',
  // maxH: "85vh",
};
// const Accordion = styled((props) => (
//   <MuiAccordion disableGutters elevation={0} square {...props} />
// ))(({ theme }) => ({
//   border: `1px solid ${theme.palette.divider}`,
//   "&:not(:last-child)": {
//     borderBottom: 0,
//   },
//   "&::before": {
//     display: "none",
//   },
// }));
// const Accordion = styled((props) => (
//   <MuiAccordion disableGutters elevation={0} square {...props} />
// ))(({ theme }) => ({
//   border: `1px solid ${theme.palette.divider}`,
//   "&:not(:last-child)": {
//     borderBottom: 0,
//   },
//   "&::before": {
//     display: "none",
//   },
// }));

// const AccordionSummary = styled((props) => (
//   <MuiAccordionSummary
//     expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
//     {...props}
//   />
// ))(({ theme }) => ({
//   backgroundColor:
//     theme.palette.mode === "dark"
//       ? "rgba(255, 255, 255, .05)"
//       : "rgba(0, 0, 0, .03)",
//   flexDirection: "row-reverse",
//   "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
//     transform: "rotate(90deg)",
//   },
//   "& .MuiAccordionSummary-content": {
//     marginLeft: theme.spacing(1),
//   },
// }));
// const AccordionSummary = styled((props) => (
//   <MuiAccordionSummary
//     expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
//     {...props}
//   />
// ))(({ theme }) => ({
//   backgroundColor:
//     theme.palette.mode === "dark"
//       ? "rgba(255, 255, 255, .05)"
//       : "rgba(0, 0, 0, .03)",
//   flexDirection: "row-reverse",
//   "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
//     transform: "rotate(90deg)",
//   },
//   "& .MuiAccordionSummary-content": {
//     marginLeft: theme.spacing(1),
//   },
// }));
const issueTypes = [
  { label: 'Billing Issues', value: 'billing_issues' },
  { label: 'Login & Account Issues', value: 'login_account_issues' },
  { label: 'Data & Reports', value: 'data_reports' },
  { label: 'New Feature Request', value: 'new_feature_request' },
  { label: 'Bug / Technical Error', value: 'Bbug_technical_error' },
  { label: 'Performance Issues', value: 'performance_issues' },
  { label: 'Training & Support', value: 'training_support' },
  { label: ' Others', value: ' others' },
];
// const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
//   padding: theme.spacing(2),
//   borderTop: "1px solid rgba(0, 0, 0, .125)",
// }));

function SupportPage({ open, setOpen }) {
  const { theme } = useThemes();
  const isLaptopOrAbove = useMediaQuery((theme) => theme.breakpoints.up('md'));
  // let InitialTextfields = ({ display }) => (
  //   <Box
  //     sx={{
  //       display: display ? "flex" : "none",
  //       flexDirection: { xs: "column", md: "row" },
  //     }}
  //   >
  //     <Box sx={{ flex: 1, m: { xs: "5px", sm: 1 } }}>
  //       <TextField
  //         error={name == ""}
  //         size="small"
  //         fullWidth
  //         label="Name"
  //         value={name}
  //         InputLabelProps={{
  //           required: true, // This adds the asterisk but doesn't enforce the required validation
  //         }}
  //         onChange={(e) => setName(e.target.value)}
  //         variant="outlined"
  //         sx={{
  //           ".css-wgai2y-MuiFormLabel-asterisk": {
  //             color: "danger.main",
  //             fontSize: "20px",
  //             fontWeight: "bold",
  //           },
  //         }}
  //       />
  //     </Box>
  //     <Box sx={{ flex: 1, m: { xs: "5px", sm: 1 }, marginBottom: 1 }}>
  //       <CustomPhoneInputBox
  //         name="mobile"
  //         required={true}
  //         label="Mobile Number"
  //         defaultCountry="IN"
  //         focusOnSelectCountry={true}
  //         forceCallingCode={true}
  //         disableFormatting={true}
  //         onChange={(e) => {
  //           setPhone(e);
  //           if (!matchIsValidTel(e)) {
  //             validateInputs(phone); //debounce
  //             setError((prev) => ({
  //               ...prev,
  //               errorFields: {
  //                 ...prev.errorFields,
  //                 mobile: "Invalid Mobile Number",
  //               },
  //               errorStatus: {
  //                 ...prev.errorStatus,
  //                 mobile: true,
  //               },
  //             }));
  //           } else
  //             setError((prev) => ({
  //               ...prev,
  //               errorFields: {
  //                 ...prev.errorFields,
  //                 mobile: "",
  //               },
  //               errorStatus: {
  //                 ...prev.errorStatus,
  //                 mobile: false,
  //               },
  //             }));
  //         }}
  //         state={error}
  //         value={phone}
  //       />
  //     </Box>
  //   </Box>
  // );

  const [index, setIndex] = useState(0);

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
    validateInputs('email', e.target.value);
  };

  const handleChangePhone = (e) => {
    const value = e?.replace(/[^0-9+]/g, '');
    setPhone(value);
    validateInputs('phone');
  };
  const handleChangeIndex = (index) => {
    setIndex(index);
  };

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [issueType, setIssueType] = useState('');
  const [description, setDescription] = useState('');
  const [phone, setPhone] = useState('');
  const [pageUrl, setPageUrl] = useState('');
  const [error, setError] = useState({
    errorFields: { mobile: '', email: '', name: '', description: '', shortDescription: '' },
    errorStatus: {
      mobile: false,
      email: false,
      issueType: false,
      name: false,
      description: false,
      shortDescription: false,
    },
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filePreviews, setFilePreviews] = useState([]);
  const ItemImageRefs = useRef([]);
  const linkImageRefs = useRef([]);
  const [expanded, setExpanded] = useState('panel1');
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [questionSearch, setQuestionSearch] = useState('');
  const [expandedSections, setExpandedSections] = useState([]);
  const [faqResult, setFaqResult] = useState(false);
  const [isCopyBoxActive, setCopyBoxActive] = useState(false);
  const location = useLocation();
  const [personalName, setPersonalName] = useState();
  const [ShortDis, setShortDis] = useState('');

  useEffect(() => {
    if (questionSearch.trim() === '') {
      setExpandedSections([]);
      return;
    }

    const matches = frequentlyAsked
      .map((section, idx) => {
        const filtered = section.questions.filter((q) => q.title.toLowerCase().includes(questionSearch.toLowerCase()));
        return filtered.length > 0 ? idx : null;
      })
      .filter((idx) => idx !== null);

    if (matches.length === 0 && questionSearch.trim() !== '') {
      setFaqResult(true);
    } else {
      setFaqResult(false);
    }

    setExpandedSections(matches);
  }, [questionSearch, frequentlyAsked]);

  const handleToggle = (sectionIndex) => {
    setExpandedSections((prev) => (prev.includes(sectionIndex) ? prev.filter((i) => i !== sectionIndex) : [...prev, sectionIndex]));
  };
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);
  // console.log(uploadedFile, "////")
  const validateInputs = useCallback(
    useDebounce((value, emailValue) => {
      if (!validateEmail(emailValue) && value == 'email') {
        setError((prev) => ({
          ...prev,
          errorFields: {
            ...prev.errorFields,
            email: 'Please enter a valid email address.',
          },
          errorStatus: {
            ...prev.errorStatus,
            email: true,
          },
        }));
        // showWarningSnackbar(`Please enter a valid email address.`);
      }
      if (value == 'phone') {
        setError((prev) => ({
          ...prev,
          errorFields: {
            ...prev.errorFields,
            phone: 'Invalid Mobile Number',
          },
        }));
        showWarningSnackbar('Please enter a valid phone number.');
      }
    }, 500),
    []
  );

  function highlightQuestion(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: 'yellow', fontWeight: 600 }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  const validateEmail = (email) => {
    const emailPattern =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (emailPattern.test(email)) {
      setError((prev) => ({
        ...prev,
        errorFields: {
          ...prev.errorFields,
          email: '',
        },
        errorStatus: {
          ...prev.errorStatus,
          email: false,
        },
      }));
    }
    console.log(email, '/', emailPattern.test(email));
    return emailPattern.test(email);
  };

  function companyValid(name) {
    console.log(name, '====> name');

    const nameText = /^[a-zA-Z0-9.&' @_",()/-]+$/;
    const isValid = name.trim() !== '' && nameText.test(name);

    setError((prev) => ({
      ...prev,
      errorFields: {
        ...prev.errorFields,
        name: isValid ? '' : 'Enter a valid Company Name',
      },
      errorStatus: {
        ...prev.errorStatus,
        name: !isValid,
      },
    }));

    return isValid;
  }

  const fetchCompany = async () => {
    try {
      let data = getCompany;
      console.log(getCompany, '///...//');
      setName(data.companyname || '');
      setEmail(data.relatedemailcontacts[0].emailaddress ? data.relatedemailcontacts[0].emailaddress : '');
      setPhone(data.relatedphonecontacts[0].phonenumber ? data.relatedphonecontacts[0].phonenumber : '');
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (open == true) {
      fetchCompany();
    }

    return () => {};
  }, [open]);

  const validationSubmit = useCallback(() => {
    if (!companyValid(name)) {
      showWarningSnackbar('Give valid Company Name');
      const focus = document.getElementById('companyName');
      focus.focus();
      return false;
    }

    if (!matchIsValidTel(phone)) {
      showWarningSnackbar('Give valid Phone number');
      const focusPhone = document.getElementById('MuiTelInput');
      if (focusPhone) {
        focusPhone.focus();
      }
      return false;
    }
    if (!validateEmail(email)) {
      const emailFocus = document.getElementById('email');
      emailFocus.focus();
      showWarningSnackbar('Give valid Email');
      return false;
    }
    if (issueType == '') {
      setError((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          issueType: true,
        },
      }));
      const typeFocus = document.getElementById('issueType');
      typeFocus.focus();
      showWarningSnackbar('Issue Type is Mandatory');
      return false;
    }
    if (ShortDis == '') {
      setError((prev) => ({
        ...prev,
        errorStatus: {
          shortDescription: true,
        },
      }));
      const shortDesFocus = document.getElementById('shortDescription');
      shortDesFocus.focus();
      showWarningSnackbar('Short Description is Mandatory');
      return false;
    }
    if (description == '') {
      setError((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          description: true,
        },
      }));
      const descriptionFocus = document.getElementById('description');
      descriptionFocus.focus();
      showWarningSnackbar('Description is Mandatory');
      return false;
    } else {
      return true;
    }
    // return matchIsValidTel(phone) && validateEmail(email) && issueType !== "" && description !== ""
  }, [name, phone, email, issueType, description, ShortDis]);

  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);

  let path = `${userPreferece?.financialYear?.CompanyID}/${userPreferece?.financialYear?.CompanyBranchID}/${userPreferece?.financialYear?.FinancialYearID}/`;
  const handleSubmit = useCallback(
    async (event) => {
      if (event) event.preventDefault();
      try {
        let valid = validationSubmit();
        if (valid == true) {
          setBackdropOpen(true);
          let formData = new FormData();
          let uploadedUrls = [];

          // Upload each file
          for (let i = 0; i < uploadedFiles.length; i++) {
            const file = uploadedFiles[i];
            const fileName = `support/ledgerx${Date.now()}_${i}_${getLastAuthUser()}-support.${file.name.split('/').pop()}`;
            await uploadToServer(file, fileName, file.type);
            uploadedUrls.push(`${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${fileName}`);
          }

          formData.append(
            'data',
            JSON.stringify({
              name,
              email,
              issueType,
              description,
              phone,
              // type: uploadedFiles.map(file => file.type).join(','),
              url: uploadedUrls.length > 0 ? uploadedUrls[0] : '',
              type: uploadedFiles.length > 0 ? uploadedFiles[0].type : '',
            })
          );

          const formDatas = {
            company_name: name,
            mobile_number: phone,
            email: email,
            issue_type: issueType,
            description: description,
            attachment: uploadedUrls,
            environment: process.env.REACT_APP_ENV || 'NAN',
            pageurl: pageUrl,
            short_discription: ShortDis,
            personal_name: personalName,
          };
          // Make API call (returns { success, task_id, task_url, message, ... })
          let taskId = '';
          try {
            const bugRes = await axios.post('https://crm.ledgerx.biz/api/create_bugs', formDatas);
            taskId = String(bugRes?.data?.task_id ?? '');
          } catch (error) {
            console.error('Error creating bug:', error);
          }

          axiosInstanceForLambda
            .post(API_ENDPOINTS.REACT_APP_SUPPORT_URL, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then((res) => {
              console.log(res);
              // downloadFileFromBase64(res.data, 'file.png')
            })
            .catch((e) => {
              console.log(e);
            });

          console.log(
            {
              name: { value: name, type: typeof name },
              email: { value: email, type: typeof email },
              issueType: { value: issueType, type: typeof issueType },
              description: { value: description, type: typeof description },
              phone: { value: phone, type: typeof phone },
              // filename: { value: fileName, type: typeof fileName },
              pageurl: { value: pageUrl, type: typeof pageUrl },
            },
            '***********yyyyy'
          );

          let response = await API.graphql(
            graphqlOperation(createuserissue, {
              userIssueInput: {
                name: name,
                email: email,
                phone: phone,
                issuetype: issueType,
                status: 'new',
                description: description,
                filename: uploadedUrls.join(','), // Join multiple filenames with comma
                pageurl: pageUrl,
                shortdescription: ShortDis,
                personalname: personalName,
              },
            })
          );

          showSuccessSnackbar(taskId ? `Issue reported! Reference ID: ${taskId}` : 'Issue reported!');
          document.getElementById('myForm').reset();
          clearAllFiles();
          setDescription('');
          setIssueType('');
          setPageUrl(window.location.href);
          console.log(response);
          setBackdropOpen(false);
        }
        // else showWarningSnackbar("Complete the Mandatory Fields")
      } catch (error) {
        showWarningSnackbar('Something went wrong !');
        console.log(error, '======>errorrrr');
        setBackdropOpen(false);
      }
    },
    [name, email, issueType, description, phone, uploadedFiles, pageUrl, ShortDis, personalName, validationSubmit]
  );

  const handleFileChange = (event) => {
    const files = Array.from(event?.target?.files || event?.dataTransfer?.files || event?.clipboardData?.files || []);
    const MAX_FILES = 5;
    const MAX_FILE_SIZE = 20 * 1024 * 1024;

    if (files.length === 0) return;

    // Check file count limit
    if (uploadedFiles.length + files.length > MAX_FILES) {
      showErrorSnackbar(`Maximum ${MAX_FILES} files allowed`);
      return;
    }

    files.forEach((file) => {
      // Check file type
      if (!supportedFileTypes.includes(file.type)) {
        showErrorSnackbar(`Unsupported file type: ${file.name}. Please upload a JPEG, PNG, PDF, DOCX, TXT, Excel or CSV file.`);
        return;
      }

      // Check file size
      if (file.size > MAX_FILE_SIZE) {
        showErrorSnackbar(`File too large: ${file.name}. Maximum size is 20MB.`);
        return;
      }

      // Add file to array
      setUploadedFiles((prev) => [...prev, file]);

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setFilePreviews((prev) => [...prev, { file, previewUrl }]);
    });
  };

  const removeFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setFilePreviews((prev) => {
      const newPreviews = [...prev];
      URL.revokeObjectURL(newPreviews[index].previewUrl);
      return newPreviews.filter((_, i) => i !== index);
    });
  };

  useEffect(() => {
    if (!open) return;
    const currentLocation = window.location.href;
    setPageUrl(currentLocation);
  }, [open]);

  const replaceFile = (index) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = false;
    input.onchange = (e) => {
      const newFile = e.target.files[0];
      if (newFile) {
        if (!supportedFileTypes.includes(newFile.type)) {
          showErrorSnackbar(`Unsupported file type: ${newFile.name}. Please upload a JPEG, PNG, PDF, DOCX, TXT, Excel or CSV file.`);
          return;
        }
        if (newFile.size > 10 * 1024 * 1024) {
          showErrorSnackbar(`File too large: ${newFile.name}. Maximum size is 10MB.`);
          return;
        }
        setUploadedFiles((prev) => prev.map((file, i) => (i === index ? newFile : file)));
        setFilePreviews((prev) => {
          const newPreviews = [...prev];
          URL.revokeObjectURL(newPreviews[index].previewUrl);
          newPreviews[index] = { file: newFile, previewUrl: URL.createObjectURL(newFile) };
          return newPreviews;
        });
      }
      e.target.value = '';
    };
    input.click();
  };

  const clearAllFiles = useCallback(() => {
    filePreviews.forEach((preview) => URL.revokeObjectURL(preview.previewUrl));
    setUploadedFiles([]);
    setFilePreviews([]);

    // Reset file input to allow same file selection again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }, [filePreviews]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  function handleClose() {
    setOpen(false);
    clearAllFiles();
    setError({
      errorFields: { mobile: '', email: '', name: '', description: '' },
      errorStatus: {
        mobile: false,
        email: false,
        issueType: false,
        name: false,
        description: false,
      },
    });
    setFaqResult(false);
    setExpandedSections([]);
    setQuestionSearch('');
    setPageUrl('');
    setIssueType('');
    setDescription('');
  }
  const [isCapturing, setIsCapturing] = useState(false);
  const fileInputRef = useRef();

  useEffect(() => {
    const controlAndS = async (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's' && open) {
        e.preventDefault();
        await handleSubmit();
        // showErrorSnackbar("Nothing to saveeeee");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, [open, handleSubmit]);

  const captureScreenshot = async (e) => {
    setIsCapturing(true);
    try {
      // Request screen capture permission
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: { displaySurface: 'browser' },
      });

      console.log(stream, '****stream');
      // Create a video element to hold the stream
      const video = document.createElement('video');
      video.srcObject = stream;

      console.log(video, '***video');

      // Wait until the video is ready
      await new Promise((resolve) => {
        video.onloadedmetadata = () => {
          video.play();
          resolve();
        };
      });

      // Create a canvas to capture the image
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');

      // Draw the current video frame to the canvas (this is the screenshot)
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Stop the screen capture stream immediately after capturing
      stream.getTracks().forEach((track) => track.stop());

      // Convert the canvas to a Blob and then to a File
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      const file = new File([blob], 'screenshot.png', { type: 'image/png' });

      // Add screenshot to files array
      setUploadedFiles((prev) => [...prev, file]);

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setFilePreviews((prev) => [...prev, { file, previewUrl }]);

      setIsCapturing(false); // End capture
    } catch (error) {
      console.error('Screen capture failed:', error);
      setIsCapturing(false);
    }
  };
  const isSmallDvce = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Modal
      id={open ? 'supportModal' : ''}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleClose();
      }}
      sx={{ display: isCapturing ? 'none' : 'block' }}
    >
      <Fade in={open}>
        <Paper
          // sx={{
          //     // display: "flex",
          //     flexDirection: "column",
          //     paddingTop: "80px",
          //     paddingLeft: { xs: "8px", sm: "70px", lg: "80px" },
          //     paddingRight: { xs: "8px", lg: "30px" },
          //     paddingBottom: "8px",
          //     boxSizing: "content-box",
          // }}
          sx={style}
        >
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 12px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                Support
                <IconButton aria-label="delete" onClick={handleClose}>
                  <Close sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Paper
            sx={{
              display: 'flex',
              alignItems: 'center',
              m: { xs: 0.5, sm: 1 },
              borderRadius: '8px',
              backgroundColor: 'background.paper',
              boxShadow: 'none',
              transition: 'all 1s ease-in-out',
              overflow: 'hidden',
              flexWrap: { xs: 'nowrap', sm: 'nowrap' },
            }}
          >
            {/* Navigation Buttons for each Step */}
            <Box
              sx={{
                mx: { xs: 0.25, sm: 1 },
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                padding: { xs: '6px 4px', sm: '9px 16px' },
                borderBottom: 'solid 2px',
                borderColor: index === 0 ? 'primary.main' : 'transparent',
                cursor: 'pointer',
                color: 'primary.main',
                transition: 'ease-in-out .4',
                flex: { xs: 1, sm: 'none' },
                minWidth: 0,
              }}
              onClick={() => setIndex(0)}
            >
              <Typography
                sx={{
                  fontSize: { xs: '10px', sm: '12px' },
                  marginLeft: { xs: '0px', sm: '5px' },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Report
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                mx: { xs: 0.25, sm: 1 },
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                padding: { xs: '6px 4px', sm: '9px 16px' },
                borderBottom: 'solid 2px',
                borderColor: index === 1 ? 'primary.main' : 'transparent',
                cursor: 'pointer',
                color: 'primary.main',
                transition: 'ease-in-out .4',
                flex: { xs: 1, sm: 'none' },
                minWidth: 0,
              }}
              onClick={() => setIndex(1)}
            >
              <Typography
                sx={{
                  fontSize: { xs: '10px', sm: '12px' },
                  marginLeft: { xs: '0px', sm: '5px' },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                FAQ
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                mx: { xs: 0.25, sm: 1 },
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                padding: { xs: '6px 4px', sm: '9px 16px' },
                borderBottom: 'solid 2px',
                borderColor: index === 2 ? 'primary.main' : 'transparent',
                cursor: 'pointer',
                color: 'primary.main',
                transition: 'ease-in-out .4',
                flex: { xs: 1, sm: 'none' },
                minWidth: 0,
              }}
              onClick={() => setIndex(2)}
            >
              <Typography
                sx={{
                  fontSize: { xs: '10px', sm: '12px' },
                  marginLeft: { xs: '0px', sm: '5px' },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Contact Us
              </Typography>
            </Box>
          </Paper>

          <Box
            sx={{
              maxHeight: { md: '70vh', xs: 'calc(100vh - 200px)' },
              overflowY: 'auto',
              overflowX: 'hidden',
              flexGrow: 1,
            }}
          >
            {/* <SwipeableViews
              index={index}
              onChangeIndex={handleChangeIndex}
              style={{ maxHeight: isSmallDvce ? "70vh" : "" }}
            > */}

            <Box style={{ maxHeight: isSmallDvce ? '70vh' : '' }}>
              {index == '0' ? (
                <>
                  <Paper
                    sx={{
                      m: 1,
                      mt: 0,
                      flex: 1,
                      display: 'flex',
                      padding: { xs: '0', sm: '10px', md: '2px' },
                      // pt: '5px',
                      flexDirection: 'column',
                      borderRadius: '8px',
                      // boxShadow:
                      //     "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                      // ":hover": {
                      //     boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)"
                      // },
                      boxShadow: 'none',
                      transition: 'all 1s ease-in-out',
                      // height: { xs: "80%", sm: "" },
                    }}
                  >
                    <Typography
                      sx={{
                        flex: 1,
                        display: 'block',
                        fontWeight: 600,
                        fontSize: { xs: '16px', md: '18px' },
                        textAlign: 'center', // changed from justifyContent on 'display: flex'
                        mb: 2,
                        color: '#911b7c',
                      }}
                    >
                      Report Issue
                    </Typography>

                    <Grid container spacing={1}>
                      <Grid item xs={12} md={6} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}>
                        <Box
                          sx={{
                            display: { xs: 'none', sm: 'none', md: 'flex' },
                            flexDirection: 'column',
                            alignItems: 'center',
                            // justifyContent: "center",
                            // width: '100%', // full width
                            // height: "100%" // auto height for smaller screens
                            // backgroundImage: `url(${support})`,
                            // backgroundSize: 'contain',
                            // backgroundRepeat: 'no-repeat'
                          }}
                        >
                          <InitialTextfields
                            display={true}
                            name={name}
                            setName={setName}
                            setPhone={setPhone}
                            phone={phone}
                            setError={setError}
                            error={error}
                          />
                          <Box sx={{ height: '80%' }}>
                            <Box component={'img'} src={support} sx={{ height: { sm: '250px', md: '340px' } }} alt="Support" />
                          </Box>
                        </Box>
                      </Grid>

                      <Grid
                        className="custom-scrollbar"
                        item
                        xs={12}
                        md={6}
                        // sx={{ height: { xs: "65vh", sm: "100%" }, overflowX: "hidden", overflowY: { xs: "scroll", sm: "hidden" } }}
                      >
                        <form id="myForm" onSubmit={handleSubmit}>
                          <Box sx={{}}>
                            <InitialTextfields
                              display={!isLaptopOrAbove}
                              name={name}
                              setName={setName}
                              setPhone={setPhone}
                              phone={phone}
                              setError={setError}
                              error={error}
                            />
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                              }}
                            ></Box>
                            {/* <Box sx={{ margin: "-5px 16px" }}>
                              <TextField
                                size="small"
                                fullWidth
                                label="Description"
                                multiline
                                minRows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                margin="normal"
                                variant="outlined"
                              />
                            </Box> */}

                            <Box sx={{ m: { xs: '5px', sm: 1 } }}>
                              <Grid container spacing={1} alignItems="stretch">
                                <Grid xs={12} sm={6} item>
                                  <Box sx={{}}>
                                    {/* <FormControl fullWidth margin="normal">
                                  <InputLabel>Issue Type</InputLabel>
                                  <Select
                                    value={issueType}
                                    onChange={(e) =>
                                      setIssueType(e.target.value)
                                    }
                                    label="Issue Type"
                                  >
                                    <MenuItem value="login_problems">
                                      Login Problems
                                    </MenuItem>
                                    <MenuItem value="billing_issues">
                                      Billing Issues
                                    </MenuItem>
                                    <MenuItem value="technical_error">
                                      Technical Error
                                    </MenuItem>
                                  </Select>
                                </FormControl> */}
                                    <TextField
                                      label="Contact Name"
                                      size="small"
                                      fullWidth
                                      onChange={(e) => setPersonalName(e.target.value)}
                                      InputLabelProps={
                                        {
                                          // shrink: true,
                                        }
                                      }
                                      sx={{
                                        '& .MuiInputBase-input::placeholder': {
                                          fontSize: '12px',
                                          color: 'text.secondary',
                                          opacity: 0.7,
                                        },
                                      }}
                                    />
                                  </Box>
                                </Grid>

                                <Grid xs={12} sm={6} item>
                                  <Box sx={{}}>
                                    <TextField
                                      error={error.errorFields.email !== ''}
                                      size="small"
                                      fullWidth
                                      label="Email"
                                      type="email"
                                      id="email"
                                      value={email}
                                      InputLabelProps={{
                                        required: true, // This adds the asterisk but doesn't enforce the required validation
                                      }}
                                      onChange={(e) => handleChangeEmail(e)}
                                      // onChange={(e) => setEmail(e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '.css-wgai2y-MuiFormLabel-asterisk': {
                                          fontSize: '20px',
                                          fontWeight: 'bold',
                                          color: 'danger.main',
                                        },
                                      }}
                                    />
                                    <span sx={{ fontSize: '12px', marginLeft: '10px' }}>
                                      <Typography
                                        sx={{
                                          marginTop: '5px',
                                          marginLeft: '10px',
                                          fontSize: '12px',
                                          color: '#e55353',
                                        }}
                                      >
                                        {error?.errorFields?.email}
                                      </Typography>
                                    </span>
                                  </Box>
                                </Grid>

                                <Grid xs={12} sm={6} item>
                                  <Autocomplete
                                    size="small"
                                    fullWidth
                                    options={issueTypes}
                                    value={issueType}
                                    id="issueType"
                                    onChange={(event, newValue) => {
                                      setIssueType(newValue.label);
                                      setError((prev) => ({
                                        ...prev,
                                        errorStatus: {
                                          ...prev.errorStatus,
                                          issueType: false,
                                        },
                                      }));
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        error={error.errorStatus.issueType == true}
                                        InputLabelProps={{
                                          // shrink: true,
                                          required: true, // This adds the asterisk without enforcing required validation
                                        }}
                                        label="Issue Type"
                                        variant="outlined"
                                        sx={{
                                          '.css-wgai2y-MuiFormLabel-asterisk': {
                                            color: 'danger.main',
                                            fontSize: '20px',
                                            fontWeight: 'bold',
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </Grid>

                                <Grid xs={12} sm={6} item>
                                  <TextField
                                    id="shortDescription"
                                    label="Short Description"
                                    fullWidth
                                    error={error.errorStatus.shortDescription}
                                    onChange={(e) => {
                                      setShortDis(e.target.value);
                                      setError((prev) => ({
                                        ...prev,
                                        errorStatus: {
                                          ...prev.errorStatus,
                                          shortDescription: false,
                                        },
                                      }));
                                    }}
                                    size="small"
                                    InputLabelProps={{
                                      // shrink: true,
                                      required: true,
                                    }}
                                    sx={{
                                      '& .MuiInputBase-input::placeholder': {
                                        fontSize: '12px',
                                        color: 'text.secondary',
                                        opacity: 0.7,
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  style={{
                                    margin: 0,
                                    paddingTop: '0px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginTop: '10px',
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    error={error.errorStatus.description}
                                    label="Description"
                                    id="description"
                                    multiline
                                    rows={3}
                                    value={description}
                                    onChange={(e) => {
                                      setDescription(e.target.value);
                                      setError((prev) => ({
                                        ...prev,
                                        errorStatus: {
                                          ...prev.errorStatus,
                                          description: false,
                                        },
                                      }));
                                    }}
                                    // margin="normal"
                                    variant="outlined"
                                    style={{ flex: 1 }}
                                    InputLabelProps={{
                                      required: true, // This adds the asterisk but doesn't enforce the required validation
                                    }}
                                    sx={{
                                      '.css-wgai2y-MuiFormLabel-asterisk': {
                                        color: 'danger.main',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                      },
                                    }}
                                    InputProps={{
                                      classes: {
                                        input: 'custom-scrollbar', // Your custom class
                                      },
                                    }}
                                  />
                                </Grid>

                                <Grid xs={12} sm={7} item sx={{ mt: '10px', position: 'relative' }}>
                                  <TextField
                                    id="outlined-basic"
                                    label="Page URL (where the issue occurs)"
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: '100%' }}
                                    value={pageUrl}
                                    onChange={(e) => {
                                      setPageUrl(e.target.value);
                                    }}
                                  />
                                  {pageUrl && (
                                    <CloseIcon
                                      sx={{
                                        fontSize: '14px',
                                        position: 'absolute',
                                        right: '5px',
                                        top: '10px',
                                        color: '#911b7c',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => setPageUrl('')}
                                    />
                                  )}
                                </Grid>

                                <Grid xs={12} sm={5} item sx={{ mt: '10px' }}>
                                  <Button
                                    onClick={captureScreenshot}
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                      // flex: 1,
                                      // m: { xs: '5px', sm: 1 },
                                      fontSize: { xs: '0.75rem', md: '0.8rem' },
                                      width: '100%',
                                    }}
                                  >
                                    Take Snapshot
                                  </Button>
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  style={{
                                    display: 'flex',
                                    paddingTop: '10px',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      flex: 1,
                                      mt: '0px',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        display: uploadedFiles.length === 0 ? 'flex' : 'none',
                                        gap: '5px',
                                        height: '100px',
                                      }}
                                    >
                                      <Button
                                        disableElevation
                                        disableRipple
                                        size="medium"
                                        variant="text"
                                        component="label"
                                        sx={{
                                          textTransform: 'none',
                                          border: '1px dashed',
                                          borderColor: 'input.border',
                                          position: 'relative',
                                          color: 'input.font',
                                          display: uploadedFiles.length === 0 ? 'flex' : 'none',
                                          flexDirection: 'column',
                                          width: '70%',
                                          height: '100%',
                                        }}
                                        onDragOver={(event) => {
                                          event.preventDefault();
                                          event.dataTransfer.dropEffect = 'copy';
                                        }}
                                        onDrop={(event) => {
                                          event.preventDefault();
                                          handleFileChange(event);
                                        }}
                                      >
                                        {/* Label */}
                                        <Typography
                                          sx={{
                                            fontSize: { xs: '0.55em', sm: '0.65em', md: '0.75em' }, // Responsive text
                                            position: 'absolute',
                                            top: '-10px',
                                            left: '9px',
                                            background: !theme?.palette?.TmId.id.toString().includes('9') ? '#fff' : '#1E1E1E',
                                            padding: '0px 2px',
                                            color: 'input.font',
                                          }}
                                        >
                                          Attachments
                                        </Typography>

                                        {/* Icon */}
                                        <AddPhotoAlternate
                                          sx={{
                                            height: { xs: '20px', sm: '26px', md: '30px' }, // Responsive icon size
                                            marginRight: '5px',
                                            color: 'input.font',
                                            fontSize: { xs: '16px', sm: '18px', md: '20px' }, // Responsive font size
                                          }}
                                        />

                                        {/* Text Body */}
                                        <Typography
                                          color={'input.font'}
                                          sx={{
                                            textAlign: 'center',
                                            fontSize: { xs: '7px', sm: '8px', md: '10px' }, // Responsive
                                          }}
                                        >
                                          Drag and drop or select files to upload <br />
                                          (JPEG, PNG, JPG, PDF, DOCX, DOC, XLS, XLSX, CSV, TXT, PPT, MP4, MOV, AVI, MKV, WEBM) <br />
                                          Maximum 5 files, 20MB each
                                        </Typography>

                                        <input
                                          ref={fileInputRef}
                                          hidden
                                          type="file"
                                          multiple
                                          onChange={(event) => {
                                            handleFileChange(event);
                                            event.target.value = '';
                                          }}
                                        />
                                      </Button>

                                      {/* Copy Box */}
                                      <Box
                                        tabIndex={0}
                                        sx={{
                                          width: '30%',
                                          height: '100%',
                                          border: isCopyBoxActive ? '1px solid' : '1px dashed',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          cursor: 'pointer',
                                          borderColor: isCopyBoxActive ? '#bd9419ff' : 'input.border',
                                        }}
                                        onPaste={(e) => handleFileChange(e)}
                                        onClick={() => setCopyBoxActive(true)}
                                        onBlur={() => setCopyBoxActive(false)}
                                      >
                                        <Typography
                                          color={'input.font'}
                                          sx={{
                                            textAlign: 'center',
                                            fontSize: { xs: '7px', sm: '8px', md: '10px' }, // Responsive
                                          }}
                                        >
                                          You Can Copy and Paste Files Here
                                        </Typography>
                                      </Box>
                                    </Box>

                                    {/* Multiple Files Display */}
                                    {uploadedFiles.length > 0 && (
                                      <Box
                                        sx={{
                                          width: '100%',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          maxHeight: '200px',
                                          overflowY: 'auto',
                                          mb: 2,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontSize: '0.75em',
                                            letterSpacing: '0.00938em',
                                            marginBottom: '10px',
                                            color: 'input.label',
                                            fontWeight: 'bold',
                                          }}
                                        >
                                          Uploaded Files ({uploadedFiles.length}/5)
                                        </Typography>
                                        {uploadedFiles.map((file, index) => (
                                          <Box
                                            key={index}
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              p: 1,
                                              border: '1px solid #ddd',
                                              mb: 1,
                                              borderRadius: 1,
                                              backgroundColor: 'background.paper',
                                            }}
                                          >
                                            {/* File Icon/Preview */}
                                            {/* <Tooltip 
                                              title={
                                                file.type?.startsWith('video/') 
                                                  ? `Click to view video: ${file.name}` 
                                                  : file.name
                                              } 
                                              arrow
                                            > */}
                                            <Box sx={{ mr: 1, cursor: file.type?.startsWith('video/') ? 'pointer' : 'default' }}>
                                              {file.type?.split('/')?.slice(-1)[0]?.includes('png') ||
                                              file.type?.split('/')?.slice(-1)[0]?.includes('jpg') ||
                                              file.type?.split('/')?.slice(-1)[0]?.includes('jpeg') ? (
                                                <img
                                                  src={filePreviews[index]?.previewUrl}
                                                  alt="Preview"
                                                  style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    objectFit: 'cover',
                                                    borderRadius: '4px',
                                                  }}
                                                />
                                              ) : file.type?.startsWith('video/') ? (
                                                <Box sx={{ position: 'relative' }}>
                                                  <video
                                                    src={filePreviews[index]?.previewUrl}
                                                    style={{
                                                      width: '30px',
                                                      height: '30px',
                                                      objectFit: 'cover',
                                                      borderRadius: '4px',
                                                    }}
                                                    muted
                                                    onMouseEnter={(e) => e.target.play()}
                                                    onMouseLeave={(e) => {
                                                      e.target.pause();
                                                      e.target.currentTime = 0;
                                                    }}
                                                    onError={(e) => {
                                                      // Fallback to icon if video fails to load
                                                      e.target.style.display = 'none';
                                                      e.target.nextSibling.style.display = 'block';
                                                    }}
                                                  />
                                                  <img
                                                    src={file}
                                                    alt="Video"
                                                    style={{
                                                      width: '30px',
                                                      height: '30px',
                                                      objectFit: 'contain',
                                                      display: 'none',
                                                      position: 'absolute',
                                                      top: 0,
                                                      left: 0,
                                                    }}
                                                  />
                                                </Box>
                                              ) : (
                                                <img
                                                  src={
                                                    file.type?.split('/')?.slice(-1)[0]?.includes('pdf')
                                                      ? pdf
                                                      : file.type?.split('/')?.slice(-1)[0]?.includes('csv')
                                                      ? csv
                                                      : file.type?.split('/')?.slice(-1)[0]?.includes('sheet')
                                                      ? excel
                                                      : file.type?.split('/')?.slice(-1)[0]?.includes('document')
                                                      ? docx
                                                      : file
                                                  }
                                                  alt="File"
                                                  style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </Box>
                                            {/* </Tooltip> */}

                                            {/* File Info */}
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                              <Tooltip title={file.name} arrow>
                                                <Typography
                                                  sx={{
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    fontWeight: 'medium',
                                                    cursor: file.type?.startsWith('video/') ? 'pointer' : 'default',
                                                  }}
                                                  onClick={() => {
                                                    if (file.type?.startsWith('video/')) {
                                                      window.open(filePreviews[index]?.previewUrl, '_blank');
                                                    }
                                                  }}
                                                >
                                                  {file.name}
                                                  {file.type?.startsWith('video/') && ' 🎥'}
                                                </Typography>
                                              </Tooltip>
                                              <Typography
                                                sx={{
                                                  fontSize: '10px',
                                                  color: 'text.secondary',
                                                }}
                                              >
                                                {(file.size / 1024).toFixed(1)} KB
                                                {file.type?.startsWith('video/') && ' • Video'}
                                              </Typography>
                                            </Box>

                                            {/* Action Buttons */}
                                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                              <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => replaceFile(index)}
                                                sx={{ fontSize: '10px', minWidth: 'auto', px: 1 }}
                                              >
                                                Replace
                                              </Button>
                                              <Button
                                                size="small"
                                                variant="outlined"
                                                color="error"
                                                onClick={() => removeFile(index)}
                                                sx={{ fontSize: '10px', minWidth: 'auto', px: 1 }}
                                              >
                                                Remove
                                              </Button>
                                            </Box>
                                          </Box>
                                        ))}
                                      </Box>
                                    )}
                                    {uploadedFiles.length > 0 && (
                                      <Box sx={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          sx={{
                                            marginTop: '10px',
                                            fontSize: {
                                              xs: '0.75rem',
                                              sm: '12px',
                                            },
                                            flex: 1,
                                            minWidth: '120px',
                                          }}
                                        >
                                          {uploadedFiles.length > 0 && 'Add More Files'}
                                          <input
                                            hidden
                                            type="file"
                                            multiple
                                            onChange={(event) => {
                                              handleFileChange(event);
                                              event.target.value = '';
                                            }}
                                          />
                                        </Button>
                                        {uploadedFiles.length > 0 && (
                                          <Button
                                            variant="outlined"
                                            color="error"
                                            sx={{
                                              marginTop: '10px',
                                              fontSize: {
                                                xs: '0.75rem',
                                                sm: '12px',
                                              },
                                              flex: 1,
                                              minWidth: '120px',
                                            }}
                                            onClick={clearAllFiles}
                                          >
                                            Clear All
                                          </Button>
                                        )}
                                      </Box>
                                    )}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                m: '-5px 0px',
                              }}
                            >
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{
                                  flex: 1,
                                  m: { xs: '5px', sm: 1 },
                                  fontSize: { xs: '0.75rem', md: '0.8rem' },
                                }}
                              >
                                Send Report
                              </Button>
                            </Box>
                          </Box>
                        </form>
                      </Grid>
                    </Grid>
                  </Paper>
                </>
              ) : index == '1' ? (
                <>
                  <Box
                    sx={{
                      m: 1,
                      flex: 2,
                      // backgroundColor: "background.paper",
                      // padding: { xs: "5px", sm: "12px" },
                      // borderRadius: "8px",
                      // boxShadow:
                      //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                      // ":hover": {
                      //   boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                      // },
                      // transition: "all 1s ease-in-out",
                      // backgroundColor: "background.paper",
                      // padding: { xs: "5px", sm: "12px" },
                      // borderRadius: "8px",
                      // boxShadow:
                      //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                      // ":hover": {
                      //   boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                      // },
                      // transition: "all 1s ease-in-out",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '16px', sm: '20px' },
                        display: 'flex',
                        justifyContent: 'center',
                        color: '#911b7c',
                        px: { xs: 1, sm: 0 },
                        mb: { xs: 1, sm: 0 },
                      }}
                    >
                      Frequently Asked Questions
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: { xs: 'center', sm: 'flex-end' },
                        width: { xs: '100%', sm: '90%' },
                        position: 'relative',
                        px: { xs: 1, sm: 0 },
                        mb: { xs: 1, sm: 0 },
                      }}
                    >
                      <TextField
                        label="Search questions..."
                        variant="outlined"
                        onChange={(e) => {
                          setQuestionSearch(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Backspace') {
                            setFaqResult(false);
                          }
                        }}
                        value={questionSearch}
                        size="small"
                        sx={{
                          width: { xs: '100%', sm: '200px' },
                          maxWidth: { xs: '100%', sm: '200px' },
                          height: '20px',
                          marginBottom:'5px'
                        }}
                      />
                      {faqResult && (
                        <Typography
                          sx={{
                            position: { xs: 'static', sm: 'absolute' },
                            right: { xs: 'auto', sm: '-80px' },
                            top: { xs: 'auto', sm: 10 },
                            fontSize: '10px',
                            color: 'red',
                            mt: { xs: 0.5, sm: 0 },
                            textAlign: { xs: 'center', sm: 'left' },
                            px: { xs: 1, sm: 0 },
                          }}
                        >
                          No result found
                        </Typography>
                      )}
                    </Box>

                    <Box
                      sx={{
                        m: { xs: '5px', sm: 3 },
                        height: { xs: 'calc(100vh - 280px)', sm: '50vh', md: '50vh' },
                        maxHeight: { xs: 'calc(100vh - 280px)', sm: '50vh', md: '50vh' },
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        px: { xs: 0.5, sm: 0 },
                        pb: { xs: 2, sm: 0 },
                      }}
                    >
                      {frequentlyAsked.map((section, sectionIndex) => {
                        return (
                          <Accordion
                            key={section.heading}
                            sx={{
                              boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)',
                              border: '1px solid #ddd',
                              marginTop: '5px',
                            }}
                            expanded={expandedSections.includes(sectionIndex)}
                            onChange={() => handleToggle(sectionIndex)}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`section-${sectionIndex}-content`}
                              id={`section-${sectionIndex}-header`}
                            >
                              <Typography component="span" sx={{ color: '#911b7c', fontWeight: 'bold' }}>
                                {section.heading}
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails
                              sx={{
                                paddingLeft: { xs: '8px', sm: '20px' },
                                paddingRight: { xs: '8px', sm: '20px' },
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {section.questions.map((q, qIndex) => (
                                <Accordion key={`${sectionIndex}-${qIndex}`} sx={{ boxShadow: 'none', border: '1px solid #eee' }}>
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: { xs: '18px', sm: '24px' } }} />}
                                    aria-controls={`q-${sectionIndex}-${qIndex}-content`}
                                    id={`q-${sectionIndex}-${qIndex}-header`}
                                    sx={{ px: { xs: 0.5, sm: 2 } }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: { xs: '12px', sm: '14px' },
                                        color: '#673AB7',
                                        wordBreak: 'break-word',
                                        pr: { xs: 1, sm: 0 },
                                      }}
                                    >
                                      {highlightQuestion(q.title, questionSearch)}
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails sx={{ px: { xs: 1, sm: 2 }, pb: { xs: 2, sm: 1 } }}>
                                    <Box sx={{ fontSize: { xs: '12px', sm: '14px' }, wordBreak: 'break-word' }}>
                                      <div dangerouslySetInnerHTML={{ __html: q.discription }} />
                                    </Box>
                                  </AccordionDetails>
                                </Accordion>
                              ))}
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </Box>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      m: 1,
                      flex: 1,
                      paddingBottom: '20px',
                      borderRadius: '8px',
                      minheight: '80vh',
                      minWidth: isLaptopOrAbove ? '1000px' : '100px',
                      // boxShadow: 'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
                      // ':hover': {
                      //   boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                      // },
                      // transition: 'all 1s ease-in-out',
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                        color: '#911b7c',
                        marginBottom: '20px',
                      }}
                    >
                      Contact Us for Help
                    </Typography>
                    {/* <Typography sx={{textAlign:"center",color:"#911b7c",fontSize:"14px"}}>Our team is  here to help </Typography> */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '10px' }}>
                      <Box
                        sx={{
                          width: '40%',
                          height: '50vh',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          gap: '20px',
                          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                        }}
                      >
                        <Box
                          sx={{
                            width: '40px',
                            height: '30px',
                            background: 'linear-gradient(115deg, #ff4b7f 0%, #394fad 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                          }}
                        >
                          <MailOutlineIcon sx={{ color: 'white', fontSize: '25px' }} />
                        </Box>
                        <Box>
                          <Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>Email us at</Typography>

                          <a href="mailto:support@ledgerx.biz" style={{ textAlign: 'center', display: 'block' }}>
                            support@ledgerx.biz
                          </a>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          width: '40%',
                          height: '50vh',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          gap: '20px',
                          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                        }}
                      >
                        <Box
                          sx={{
                            width: '40px',
                            height: '30px',
                            background: 'linear-gradient(115deg, #ff4b7f 0%, #394fad 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                          }}
                        >
                          <CallIcon sx={{ color: 'white', fontSize: '25px' }} />
                        </Box>
                        <Box>
                          <Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>Call/Whatsapp Us</Typography>
                          <Typography sx={{ textAlign: 'center', opacity: 0.6 }}>Mon-Sat from : 8am to 8pm </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                            <CallIcon sx={{ fontSize: '20px' }} />
                            <a href="tel:6282000287" style={{}}>
                              +91 6282000287
                            </a>
                          </Box>
                          <Box
                            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
                            component="a"
                            href="https://wa.me/916282000287"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <WhatsAppIcon sx={{ fontSize: '20px', color: 'green' }} />
                            <Tooltip title="Click to chat with us on WhatsApp" placement="right">
                              <Typography sx={{ fontSize: '16px', color: 'blue' }}>+91 6282000287</Typography>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
            {/* </SwipeableViews> */}
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
}

export default SupportPage;

let InitialTextfields = React.memo(({ display, name, setName, setPhone, phone, setError, error }) => {
  function handleChangeName(e) {
    const newValue = e.target.value;
    setName(newValue);
    const nameText = /^[a-zA-Z0-9.&' @_",()/-]*$/;
    if (!nameText.test(newValue) || newValue === '') {
      setError((prev) => ({
        ...prev,
        errorFields: {
          ...prev.errorFields,
          name: 'Enter a valid Company Name',
        },
        errorStatus: {
          ...prev.errorStatus,
          name: true,
        },
      }));
    } else {
      setError((prev) => ({
        ...prev,
        errorFields: {
          ...prev.errorFields,
          name: '',
        },
        errorStatus: {
          ...prev.errorStatus,
          name: false,
        },
      }));
    }
  }
  return (
    <Box
      sx={{
        display: display ? 'flex' : 'none',
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Box sx={{ flex: 1, m: { xs: '5px', sm: 1 } }}>
        <TextField
          error={error.errorStatus.name}
          size="small"
          fullWidth
          id="companyName"
          label="Company Name"
          value={name}
          InputLabelProps={{
            required: true, // This adds the asterisk but doesn't enforce the required validation
          }}
          inputProps={{
            maxLength: 100,
          }}
          onChange={(e) => handleChangeName(e)}
          variant="outlined"
          sx={{
            '.css-wgai2y-MuiFormLabel-asterisk': {
              color: 'danger.main',
              fontSize: '20px',
              fontWeight: 'bold',
            },
          }}
        />
        <span sx={{ fontSize: '12px', marginLeft: '10px' }}>
          <Typography
            sx={{
              marginTop: '5px',
              marginLeft: '10px',
              fontSize: '12px',
              color: '#e55353',
            }}
          >
            {error?.errorFields?.name}
          </Typography>
        </span>
      </Box>
      <Box sx={{ flex: 1, m: { xs: '5px', sm: 1 }, marginBottom: 1 }}>
        <CustomPhoneInputBox
          name="mobile"
          required={true}
          label="Mobile Number"
          defaultCountry="IN"
          focusOnSelectCountry={true}
          forceCallingCode={true}
          disableFormatting={true}
          onChange={(e) => {
            setPhone(e);
            if (!matchIsValidTel(e)) {
              setError((prev) => ({
                ...prev,
                errorFields: {
                  ...prev.errorFields,
                  mobile: 'Invalid Mobile Number',
                },
                errorStatus: {
                  ...prev.errorStatus,
                  mobile: true,
                },
              }));
            } else
              setError((prev) => ({
                ...prev,
                errorFields: {
                  ...prev.errorFields,
                  mobile: '',
                },
                errorStatus: {
                  ...prev.errorStatus,
                  mobile: false,
                },
              }));
          }}
          state={error}
          value={phone}
        />
      </Box>
    </Box>
  );
});
